// FE 개발 default. `npm run serve:local`로 실행하면 axios baseURL이 `/__api`가 되고,
// `server/routes/__api/[...path].ts`의 Nitro dev-only 리버스 프록시를 통해
// `https://api-dev.codepresso.io`로 포워드됨.
//
// Why: 브라우저 입장에서 모든 호출이 same-origin (localhost)이 되어 AccessToken 쿠키가
// 1st-party로 저장됨 → Safari ITP / Chrome strict 3rd-party-cookie 차단 / 프라이버시
// 확장이 켜진 환경에서도 동작. 직접 `https://api-dev.codepresso.io`를 때리는 모드는
// 백엔드의 `SameSite=None+Secure` 쿠키에 의존해야 했고, 그게 위 브라우저들에서 막혔음.
//
// OAuth-redirect 흐름은 프록시를 우회하므로 (브라우저 → Google → api-dev로 직접 redirect)
// 이 흐름을 테스트하려면 별도로 처리 필요. 대부분의 dev 시나리오에서는 영향 없음.
//
// BE도 같이 띄워서 localhost:8400으로 붙고 싶으면 `local-be.ts` + `npm run serve:local-be` 사용.
export default {
    public: {
        ENVIRONMENT: 'dev',
        API_URL: '/__api',
        CODE_RUN_BRIDGE_API_URL: 'https://coderun-bridge-dev.codepresso.io',
        CODE_RUN_BRIDGE_SOCKET_URL: 'wss://coderun-bridge-dev.codepresso.io/global',
        SOCIAL_REDIRECT_URL: 'http://localhost:3000/auth/user/social',

        CODERUN_DOMAIN: 'https://coderun-dev.codepresso.io',

        MIXPANEL_TOKEN: "c20f725df035b82e467f791eeade1695",

        AWS_IDENTITY_POLL_ID: "ap-northeast-2:216a7f2c-317e-440e-bd65-785475927845",
        LEARNING_DEFAULT_DIRECTORY_BUCKET: "codepresso-global-contents-multi-file",
        LEARNING_DEFAULT_DIRECTORY_BUCKET_CLOUDFRONT_DOMAIN: "https://contents-multifile-stage.codepresso.io",
        LEARNING_USER_DIRECTORY_BUCKET: "codepresso-global-user-multi-file",
        USER_DIRECTORY_BUCKET_CLOUDFRONT_DOMAIN: "https://user-file.codepresso.io",
        LEARNING_USER_ANALYSIS_DIRECTORY_BUCKET: "codepresso-global-analysis-report-dev",
        LEARNING_USER_ANALYSIS_DIRECTORY_BUCKET_CLOUDFRONT_DOMAIN: "https://static-analysis-reports-dev.codepresso.io",

        COOKIE_DOMAIN: 'localhost',
        // onboarding/survey SDK·자산을 로드할 S3 prefix 도메인 (s3://codepresso-onboarding/{값}/). onboarding upload-s3.mjs 의 DOMAIN 과 일치해야 한다.
        SDK_ASSET_DOMAIN: 'localhost',
        MAIN_URL: 'http://localhost:3000/',
        BUILD_VERSION: 'dev',
        BUILD_COMMIT: 'local',
        BUILD_TIME: '',
        DESKTOP_APP_NAME: 'Proctive',
        DESKTOP_APP_VERSION: '1.8.0',
        PRODUCT_FRUITS_WORKSPACE_CODE: '0gIxreipuStmDVcj',
        ADAPTIVE_LECTURE_URL: 'https://dev-adaptive-lecture.codepresso.io/track-level',

        STRIPE_PUBLISHABLE_KEY: 'pk_test_51QweExQG9d1TvnQPi3QANFrRlluXXYxYVeoISEEGO2GoCbIEMRVAmVyAIWeiWjXYQ8KrWAITLWkza4EXXPEzB0Dj00Yo2sJ0FQ',
        TOSS_CLIENT_KEY: 'test_ck_6BYq7GWPVvNo669JKv4mVNE5vbo1',
        TOSS_PAYMENT_CLIENT_KEY: 'test_ck_5OWRapdA8dmEKm9MvXb63o1zEqZK',
    }
};
